import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { GridOptions, RowNodeBlock } from 'ag-grid';
import { Router } from '@angular/router';
import * as encoding from 'encoding-japanese';

import { ShipDeliService } from '../../../service/ship-deli/ship-deli.service';
import { ShipCaseService } from '../../../service/ship-case/ship-case.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { ClientReportService } from '../../../service/client-report/client-report.service';
import { CommonService } from '../../../service/common/common.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';
import { PostDataSource } from '../../../classes/dataSource/postDataSource';
import { Observable } from 'rxjs/Rx';
import { getCreateFormRequest } from '../../../util/util';
import { CreateFormService } from '../../../service/create-form/create-form.service';

declare const cwebclient:any;

@Component({
  selector: 'app-root',
  templateUrl: 'wa3040.component.html',
  styleUrls: ['wa3040.component.scss']
})
export class Wa3040Component implements AfterViewInit, DoCheck {
  private gridApi: any;
  public componentTitle = 'WA3040:出荷ケース照会';
  public updprogramCd = 'WA3040';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private selectedRowNode = {};
  private wa3042openwindow;
  private postDataSource: PostDataSource;
  private isOwnerLinked: boolean = false;

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private searchKeyKubun: any[];
  private delete: boolean = false;
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private isEnableClearFilter = null;
  private selectedCount = 0;
  private isEnableRightAreaButtons = false;
  public rowsPerPageModel = [{ value: 500, viewValue: '500' }, { value: 5000, viewValue: '5000' }];
  public rowsPerPage = config.rowsPerPageSize;
  private RowData: object[] = [];

  private isShow3041 = false;
  private isShow3042 = false;
  private isOwnerSearchNone = false;
  private isShowSendLoading = false;

  //検索条件
  private searchValue1 = null;
  private searchValue2 = null;
  private searchValue3 = null;
  private searchValue4 = null;
  private searchValue5 = null;
  private startDate = null;
  private endDate = null;
  private originalRowData: any[];

  private isDatasourceInit = false; 

  private isShowSearchBlock = true;

  // 印刷設定
  // 荷札
  private printagentCd = '';

  private carrierObj = {};
  private gridSelectAll = false;

  constructor(
    private router: Router,
    private shipDeliService: ShipDeliService,
    private shipCaseService: ShipCaseService,
    private clientReportService: ClientReportService,
    private commonService: CommonService,
    private carrierService: CarrierService,
    private createFormService: CreateFormService
  ) {
    const result = JSON.parse(sessionStorage.getItem('loginResult'));
    const querystrings = this.ownerId ? { ownerId: this.ownerId } : '';
    //SessionStorageからユーザ情報を取得、荷主ユーザか判定
    if (result !== null) {
      let user = result.user;
      this.isOwnerLinked = user.roleId == 3 ? true : false;
    }  
    this.postDataSource = new PostDataSource({
      parent: this,
      service: this.shipCaseService,
      resultKey: 'shipcases',
      querystrings: { 
        ownerId: this.ownerId,
        ownerCd: this.searchValue1,
        shipcaseCd: this.searchValue2,
        shipcaseTx: this.searchValue3,
        carrierTx: this.searchValue4,
        delitypeshortTx: this.searchValue5,
        startDate: this.startDate,
        endDate: this.endDate
      },
      beforeRequest: this.handleBeforeRequest.bind(this),
      successCallback: this.handleRequestSucc.bind(this)
    });
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowModelType: 'infinite',
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      enableServerSideSorting: true,
      enableServerSideFilter: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      cacheBlockSize: Number(this.rowsPerPage),
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3040_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.fixedDateFilterInput();
        this.fixedSelectAll()
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        //選択状態解除
        this.gridOptions.api.deselectAll();
        //ボタン非活性
        this.isEnableRightAreaButtons = false;
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        if (this.postDataSource['init'] == false) return;
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
        this.gridHelper.onRowDataChanged();
        if (this.gridSelectAll) {
          this.selectedCount = 0
          this.selectAllClick()
        }
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();
        this.selectedCount = 0;

      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        //ボタン非活性
        this.isEnableRightAreaButtons = false;
        //ソート時は選択状態の解除
        this.gridOptions.api.deselectAll();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
        this.isEnableRightAreaButtons = this.selectedCount > 0;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        pinned: true,
        suppressMenu: true
      },
      {
        headerName: '',
        field: 'col1',
        pinned: 'left',
        suppressMenu: true,
        width: 95,
        cellClass: ['tc', 'cellclass'],
        suppressMovable: true,
        cellRendererFramework: GridButtonRenderComponent,
        cellStyle: this.isOwnerLinked?{ display: 'none' }:'',
        cellRendererParams: {
          buttonText: '修正',
          onClick: this.onEditButtonClick.bind(this)
        }
      },
      {
        headerName: '出荷番号',
        headerTooltip: '出荷番号',
        field: 'shipnoCd',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('shipnoCd', 140),
        suppressMenu: true,
        sort: 'desc'
      },
      {
        headerName: 'ピック番号',
        headerTooltip: 'ピック番号',
        field: 'picknoCd',
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        width: this.getColumnWidth('picknoCd', 140),
        suppressMenu: true
      },
      {
        headerName: '出荷個口連番',
        field: 'shipcaseseqId',
        unSortIcon: true,
        width: this.getColumnWidth('shipcaseseqId', 120),
        cellClass: ['tr', 'cellclass'],
        suppressMenu: true,
        sort: 'asc'
      },
      {
        headerName: '出荷個口数',
        field: 'shipcaseNr',
        unSortIcon: true,
        width: this.getColumnWidth('shipcaseNr', 100),
        cellClass: ['tr', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '出荷ケース名',
        headerTooltip: '出荷ケース名',
        field: 'caseTx',
        width: this.getColumnWidth('caseTx', 100),
        cellClass: ['tr', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '出荷指示日',
        headerTooltip: '出荷指示日',
        field: 'shipDt',
        width: this.getColumnWidth('shipDt', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '納品書有無',
        headerTooltip: '納品書有無',
        field: 'invoiceTx',
        width: this.getColumnWidth('invoiceTx', 80),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '確定',
        headerTooltip: '確定',
        field: 'commitTx',
        unSortIcon: true,
        width: this.getColumnWidth('commitTx', 120),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '出荷ケース区分',
        field: 'typeshipcaseTx',
        unSortIcon: true,
        width: this.getColumnWidth('typeshipcaseTx', 140),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷姿',
        field: 'typeshipcasesubTx',
        unSortIcon: true,
        width: this.getColumnWidth('typeshipcasesubTx', 80),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '配送方法',
        field: 'carrierTx',
        unSortIcon: true,
        width: this.getColumnWidth('carrierTx', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '配送区分',
        field: 'delitypeshortTx',
        unSortIcon: true,
        width: this.getColumnWidth('delitypeshortTx', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '温度帯区分',
        field: 'typecoldTx',
        unSortIcon: true,
        width: this.getColumnWidth('typecoldTx', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: 'ピック箱番号',
        field: 'picknoPickcasenoCd',
        unSortIcon: true,
        width: this.getColumnWidth('picknoPickcasenoCd', 120),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '問合せNo',
        field: 'reqnoCd',
        unSortIcon: true,
        width: this.getColumnWidth('reqnoCd', 120),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '単価',
        field: 'deliunitpriceNr',
        unSortIcon: true,
        width: this.getColumnWidth('deliunitpriceNr', 80),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
        suppressMenu: true
      },
      {
        headerName: '金額',
        field: 'delipriceNr',
        unSortIcon: true,
        width: this.getColumnWidth('delipriceNr', 80),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
        suppressMenu: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        unSortIcon: true,
        width: this.getColumnWidth('ownerCd', 140),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        unSortIcon: true,
        width: this.getColumnWidth('ownerTx', 140),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '受注番号',
        headerTooltip: '受注番号',
        field: 'ordernoCd',
        unSortIcon: true,
        width: this.getColumnWidth('ordernoCd', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '届先コード',
        field: 'dtaddressCd',
        unSortIcon: true,
        width: this.getColumnWidth('dtaddressCd', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '届先名',
        field: 'dtnameTx',
        unSortIcon: true,
        width: this.getColumnWidth('dtnameTx', 140),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '届先県名',
        field: 'dtprefTx',
        unSortIcon: true,
        width: this.getColumnWidth('dtprefTx', 80),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '出荷完了日時',
        field: 'endDt',
        unSortIcon: true,
        width: this.getColumnWidth('endDt', 160),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '備考',
        headerTooltip: '備考',
        field: 'delichargememoTx',
        unSortIcon: true,
        width: this.getColumnWidth('delichargememoTx', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '商品コード',
        headerTooltip: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '商品名',
        headerTooltip: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 200),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷札備考1',
        headerTooltip: '荷札備考1',
        field: 'delimemodet1Tx',
        width: this.getColumnWidth('delimemodet1Tx', 200),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷札備考2',
        headerTooltip: '荷札備考2',
        field: 'delimemodet2Tx',
        width: this.getColumnWidth('delimemodet2Tx', 200),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷札備考3',
        headerTooltip: '荷札備考3',
        field: 'delimemodet3Tx',
        width: this.getColumnWidth('delimemodet3Tx', 200),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷札備考4',
        headerTooltip: '荷札備考4',
        field: 'delimemodet4Tx',
        width: this.getColumnWidth('delimemodet4Tx', 200),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷札備考5',
        headerTooltip: '荷札備考5',
        field: 'delimemodet5Tx',
        width: this.getColumnWidth('delimemodet5Tx', 200),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷札備考6',
        headerTooltip: '荷札備考6',
        field: 'delimemodet6Tx',
        width: this.getColumnWidth('delimemodet6Tx', 200),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '請求対象外',
        headerTooltip: '請求対象外',
        field: 'notinvoiceTx',
        unSortIcon: true,
        width: this.getColumnWidth('notinvoiceTx', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '請求対象外日時',
        headerTooltip: '請求対象外日時',
        field: 'notinvoiceDt',
        unSortIcon: true,
        width: this.getColumnWidth('notinvoiceDt', 160),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '請求対象外者名',
        headerTooltip: '請求対象外者名',
        field: 'notinvoiceuserTx',
        unSortIcon: true,
        width: this.getColumnWidth('notinvoiceuserTx', 120),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '出荷ケースID',
        field: 'shipcaseId',
        unSortIcon: true,
        width: this.getColumnWidth('shipcaseId', 120),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '出荷指示ID',
        field: 'shiphId',
        unSortIcon: true,
        width: this.getColumnWidth('shiphId', 120),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: 'バッチID',
        headerTooltip: 'バッチID',
        field: 'shTrnId',
        width: this.getColumnWidth('shTrnId', 80),
        cellClass: 'rightaligned',
        suppressMenu: true
      },
      {
        headerName: '出荷ケースコード',
        field: 'caseCd',
        unSortIcon: true,
        width: this.getColumnWidth('caseCd', 120),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        // sort: 'desc',
        unSortIcon: true,
        width: this.getColumnWidth('updDt', 200),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        unSortIcon: true,
        width: this.getColumnWidth('upduserTx', 100),
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        unSortIcon: true,
        width: this.getColumnWidth('addDt', 200),
        cellClass: ['tl', 'cellclass'],
        hide: true,
        suppressMenu: true
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        unSortIcon: true,
        width: this.getColumnWidth('adduserTx', 100),
        cellClass: ['tl', 'cellclass'],
        hide: true,
        suppressMenu: true
      },
    ];
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.searchKeyKubun = [];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.gridHelper.onViewportScrollListener = () => {
      this.fixedDateFilterInput();
    };
    // 印刷設定取得
    if (localStorage.getItem(`printagentCd`) !== null && localStorage.getItem(`printagentCd`) !== '') {
      this.printagentCd = localStorage.getItem(`printagentCd`);
    }
  }

  fixedDateFilterInput() {
    var dateFilter = this.gridView.nativeElement.querySelector('.ag-filter-filter');
    if (dateFilter == null) return;
    dateFilter.classList.add('ag-floating-filter-input');
    dateFilter.placeholder = '';
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3040_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3040_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3040_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  //表示件数の変更
  paginatorRowChange() {
    this.gridOptions.cacheBlockSize = Number(this.rowsPerPage);
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    this.gridOptions.api.onSortChanged();
    localStorage.setItem('wa3040_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'チェックした行をExcelエクスポート',
            action: () => {
              params.api.exportDataAsExcel({ onlySelected: true });
            }
          }
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.originalRowData = [];
      this.gridOptions.api.deselectAll();
    }
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    var date = new Date();
    var filters = {};

    setTimeout(() => {
      this.startDate = date.getFullYear() + '-' + this.pad(date.getMonth() + 1, 2) + '-' + this.pad(date.getDate(), 2);
      this.gridApi.api.setFilterModel(filters);
      //this.onSubmit();
    }, config.waitMsForSearchInNgAfterViewInit);
  }
  pad(num, totalStringSize) {
    var asString = num + '';
    while (asString.length < totalStringSize) asString = '0' + asString;
    return asString;
  } 

  onFilterClear() {
    this.errorInfo = '';
    this.searchByKey({});
    //選択全解除
    this.gridOptions.api.deselectAll();
    //ボタン非活性
    this.isEnableRightAreaButtons = false;   
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working2) return;
    this.working = true;
    this.working2 = true;
    this.gridHelper.prepareSelectedAnimateByNodes([this.selectedRowNode]);
    this.isShowSendLoading = true;
    // ヘッダーのオーナーを変更出来ないようにする。
    this.headerComponent.ownerSelect = true;

    setTimeout(() => {
      this.postDataSource['querystrings'] = {
        ownerId: this.ownerId,
        ownerCd: this.searchValue1,
        shipcaseCd: this.searchValue2,
        shipcaseTx: this.searchValue3,
        carrierTx: this.searchValue4,
        delitypeshortTx: this.searchValue5,
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.searchByKey({});
      if (!this.isDatasourceInit) {
        this.gridOptions.api.setDatasource(this.postDataSource);
        this.isDatasourceInit = true
      }
      // ヘッダーのオーナーを変更できるようにする。
      this.headerComponent.ownerSelect = false;
      this.gridHelper.selectedAnimateDelay();
      this.working = false;
      this.working2 = false;
    }, 1500);
  }

  upd() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    if(this.rowData == undefined || this.rowData.length == 0) this.copyRowData();
    sessionStorage.setItem('shipCase', JSON.stringify(this.rowData[selectedIndex]));
    this.router.navigate(['wa3041']);
  }

  allupd() {
    if (!this.ownerId) {
      this.errorInfo = '荷主を選択して下さい';
      return;
    }
    if (this.gridOptions.api.getDisplayedRowCount() == 0) {
      this.errorInfo = '修正対象データがありません';
      return;
    }

    this.carrierService
      .get()
      .then(outputJson => {
        console.log(outputJson)
        this.carrierObj = {};
        for (let i = 0; i < outputJson.carriers.length; i++) {
          this.carrierObj[outputJson.carriers[i].carrierCd] = outputJson.carriers[i].carrierTx;
        }

        console.log(this.carrierObj)
        sessionStorage.setItem('carrierObj', JSON.stringify(this.carrierObj));
        sessionStorage.setItem('wa3042_ownerId', String(this.ownerId));
        sessionStorage.setItem('wa3042openwindow', 'open');
        sessionStorage.setItem('isOwnerDisable', 'true');
        this.isShow3042 = true;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

  }

  del() {

    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      // push data
      const jsonUnit: object = {
        shipcaseId: this.rowData[rowIndex]['shipcaseId']
      }
      selectItems.push(jsonUnit);
    }
    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working = true;
    this.working2 = true;
    this.shipCaseService
      .delete(
        this.updprogramCd,
        selectItems
      )
      .then(outputJson => {
        this.working = false;
        this.working2 = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '削除が完了しました');
        this.delete = false;
      })
      .catch(error => {
        this.working = false;
        this.working2 = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.delete = false;
      });
  }

  checkDelete() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.delete = false;
      return;
    }
    this.copyRowData();

    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      // push data
      const jsonUnit: object = {
        shipcaseId: this.rowData[rowIndex]['shipcaseId']
      }
      selectItems.push(jsonUnit);
    }
    this.shipCaseService
      .checkDelete(
        this.updprogramCd,
        selectItems
      )
      .then(canDelete => {
        if(canDelete){
          this.delete = true;
        } else {
          this.errorInfo = '出荷指示に紐づく出荷ケースをすべて削除することはできません。';
        }
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
    });
  }

  printDeli() {
    //SW-2103　ダブルクリック抑止
    if (this.working2) return;
    if(this.rowData == undefined || this.rowData.length == 0) this.copyRowData();
    this.working2 = true;
    this.isShowSendLoading = true;
    let ownerId: number;
      
    let ownerError = false;
    let pickCaseError = false;
    //荷主同一チェック
    this.gridOptions.api.getSelectedRows().forEach(function(selectedRow, index) {
        if(index === 0){
          ownerId = selectedRow.ownerId;
        }
        else{
          if(ownerId !== selectedRow.ownerId){
            ownerError = true;
            return;
          }
        }
        if(selectedRow.caseTx == null) {
          pickCaseError = true;
          return;
        }
    });
    if(ownerError){
      this.isShowSendLoading = false;
      this.working = false;
      this.working2 = false;
      this.errorInfo = '複数荷主の指示が選択されています。同一荷主の指示のみ選択してください';
      return;
    }
    if(pickCaseError){
      this.isShowSendLoading = false;
      this.working = false;
      this.working2 = false;
      this.errorInfo = 'ピック箱が選択されています。出荷ケース名が表示されている行のみ選択してください。';
      return;
    }
      
      
    //グリッドデータのLoadingステータス確認（Loadedでない場合は処理を開始しない）
    this.checkCacheState().then(result =>{
          //荷札出力処理
    
        let selectIdSet = new Set<number>();
        let selectedRows = this.gridOptions.api.getSelectedRows();
        selectedRows.forEach(function(selectedRow, index) {
            selectIdSet.add(selectedRow.shipcaseId);
        });
    
        let sortedIdSet = new Set<number>();
        this.gridOptions.api.forEachNode(function(rowNode){
          if (selectIdSet.has(rowNode.data.shipcaseId)) {
                sortedIdSet.add(rowNode.data.shipcaseId);
          }
        });
    
        this.shipDeliService
          .printByShipcaseList(
            this.printagentCd,
            null,
            sortedIdSet,
            this.updprogramCd
          )
          .then(outputJson => {

            //荷札はポーリングで出力されるためここでは取得しない。メッセージ表示のみ
            sessionStorage.setItem('SuccessInfoMessage', '荷札出力を開始しました。');

            setTimeout(() => {
              this.isShowSendLoading = false;
              this.working = false;
              this.working2 = false;
              this.onSubmit();
              this.selectedCount = 0;
            },300);
          })
          .catch(error => {
            this.isShowSendLoading = false;
            this.working = false;
            this.working2 = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
   }).catch(error => {
      this.isShowSendLoading = false;
      this.working = false;
      this.working2 = false;
      this.errorInfo = '表示データが読み込み中であったため荷札出力を中止しました。再試行してください。';
    });
        
  }

  onEditButtonClick(node) {
    this.RowData = node['data'];
    this.selectedRowNode = node;
    this.isShow3041 = true;
  }

  ngDoCheck() {
    if (sessionStorage.getItem('openotherwindow') === 'true') {
      this.working = true;
    } else {
      this.working = false;
    }
  }

  onShow3042() {
    this.isShow3042 = true;
  }

  onClose3041(isCloseAndRefreshGrid: boolean) {
    this.isShow3041 = false;
    if (isCloseAndRefreshGrid) {
      this.gridHelper.prepareSelectedAnimateByNodes([this.selectedRowNode]);
      this.onSubmit();
    }
  }

  onClose3042(isCloseAndRefreshGrid: boolean) {
    this.isShow3042 = false;
    if (isCloseAndRefreshGrid) {
      this.gridHelper.prepareSelectedAnimateByNodes([this.selectedRowNode]);
      this.onSubmit();
    }
  }

  ownerInputChanged(ownerId: string) {
    this.errorInfo = '';
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  copyRowData(){
    this.rowData = [];
    this.gridOptions.api.forEachNode(node => this.rowData.push(node.data));
  }

  fixedSelectAll() {
    var selectAll = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.classList.remove('ag-hidden')
    selectAll.addEventListener('click', () => {
      const nodes = this.gridOptions.api.getRenderedNodes()
      if (nodes.length > 0 && nodes[0].data === null) {
        this.gridSelectAll = !this.gridSelectAll
        return
      }

      this.gridSelectAll = !this.gridSelectAll
      this.selectCurrentPage(this.gridSelectAll)
    })
  }

  selectCurrentPage (selected) {
    const startRow = (this.paginationGetCurrentPage - 1) * Number(this.rowsPerPage)
    const endRow = startRow + Number(this.rowsPerPage)

    this.gridOptions.api.forEachNode(node => {
      if (node.data)
        node.setSelected(false)
    })
    const count = this.gridOptions.api.getDisplayedRowCount()
    const limit = count < endRow ? count : endRow

    for (let i = startRow; i < endRow; i++) {
      const node = this.gridOptions.api.getDisplayedRowAtIndex(i)
      if (node.data)
        node.setSelected(selected)
    }
  }

  selectAllClick () {
    var selectAll = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.click();
  }

  handleBeforeRequest () {
    this.gridOptions.api.showLoadingOverlay();
    this.setHeaderLoadingStart();
  }

  handleRequestSucc () {
    this.gridOptions.api.hideOverlay();
    this.setHeaderLoadingEnd();
    this.isShowSendLoading = false;
  }
    
  //AGGrid ブロックキャッシュステータスチェック
  async checkCacheState(){
    const blockState = this.gridOptions.api.getCacheBlockState();
    let ret = false;
    //合計で10秒待つ
    for(let i = 0; i < 10; i++){
        if(blockState[0].pageStatus == RowNodeBlock.STATE_LOADED){
          return Promise.resolve;
        }
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    return Promise.reject('AGGrid brockCache refresh timeout'); 
  } 

  searchByKey(filters) {

    if (this.ownerId != null) {
      filters['ownerId'] = {
        type: 'contains',
        filter: this.ownerId
      };
    }

    if (this.searchValue1 != null && this.searchValue1.length > 0) {
      filters['ownerCd'] = {
        type: 'contains',
        filter: this.searchValue1
      };
    }

    if (this.searchValue2 != null && this.searchValue2.length > 0) {
      filters['shipcaseCd'] = {
        type: 'contains',
        filter: this.searchValue2
      };
    }

    if (this.searchValue3 != null && this.searchValue3.length > 0) {
      filters['caseTx'] = {
        type: 'contains',
        filter: this.searchValue3
      };
    }

    if (this.searchValue4 != null && this.searchValue4.length > 0) {
      filters['carrierTx'] = {
        type: 'contains',
        filter: this.searchValue4
      };
    }
    if (this.searchValue5 != null && this.searchValue5.length > 0) {
      filters['delitypeshortTx'] = {
        type: 'contains',
        filter: this.searchValue5
      };
    }

    if (Object.getOwnPropertyNames(filters).length == 0) {
      this.gridApi.api.setFilterModel(null);
      return
    }
    this.gridApi.api.setFilterModel(filters);

  }  
  //検索条件クリア
  clearSearchKey() {
    this.errorInfo = '';

    this.searchValue1 = null;
    this.searchValue2 = null;
    this.searchValue3 = null;
    this.searchValue4 = null;
    this.searchValue5 = null;
    this.startDate = null;
    this.endDate = null;
  }
  clearAndSubmit() {
    this.onFilterClear();
  }  
  onSearchBlockClick() {
    this.errorInfo = '';

    this.isShowSearchBlock = !this.isShowSearchBlock;
    this.gridHelper.renderScrollArrowDelay();
  }  
  clrErr() {
    this.errorInfo = '';
  }
    // ヘッダ表示をデータ取得中の状態に変更
    setHeaderLoadingStart () {
      // ヘッダを非表示にする
      this.gridView.nativeElement.querySelector('.ag-header').style.display = 'none';
      // スクロールバーを表示しない
      this.gridView.nativeElement.querySelector('.ag-body-viewport').style.overflow = 'hidden';
      // 念のためフィルターの入力を不可にする
      var filterInput = this.gridView.nativeElement.querySelectorAll('.ag-header-cell input, .ag-header-cell button');
      for(let i in filterInput){
        if (filterInput.hasOwnProperty(i)) {
          filterInput[i].disabled = true;
        }
      }
    }

    // ヘッダ表示をデータ取得中の状態から戻す
    setHeaderLoadingEnd () {
      // ヘッダの表示を戻す
      this.gridView.nativeElement.querySelector('.ag-header').style.display = 'block';
      // スクロールバーを再表示
      this.gridView.nativeElement.querySelector('.ag-body-viewport').style.overflow = 'auto';
      // フィルターの入力を可能にする
      var filterInput = this.gridView.nativeElement.querySelectorAll('.ag-header-cell input, .ag-header-cell button');
      for(let i in filterInput){
        if (filterInput.hasOwnProperty(i)) {
          filterInput[i].disabled = false;
        }
      }
    }
    onRowDataChanged() {
      this.gridHelper.onGridFilterChanged();
      this.gridHelper.onRowDataChanged();
    }    
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3040/wa3040.component.ts